import React from "react"
import { Col, Card } from "react-bootstrap"
import Img from "gatsby-image"

const BodyCard = ({ content }) => {
  return (
    Object.keys(content).map((key, i) => (
      <Col key={ i } lg={6} xs={12}>
        <Card className="c">
          <div className="top-sec">
            <Img className="c-img" fluid={ content[key].img } alt={ content[key].alt }/>
          </div>
          <div className="bottom-sec">
            <h3>{ content[key].header }</h3>
            <ul>
              { content[key].list.map((list, j) => (
                <li key={ j }>{ list }</li>
              )) }
            </ul>
          </div>
        </Card>
      </Col>
    ))
  )
}

export default BodyCard
